import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/_atoms/button";
import { cn } from "@/lib/cn";

interface PaginationControlsProps {
  page: number;
  pageCount: number;
  onPrevious: () => void;
  onNext: () => void;
  className?: string;
}

export function PaginationControls({ page, pageCount, onPrevious, onNext, className }: PaginationControlsProps) {
  const { t } = useTranslation("common");

  if (pageCount <= 1) {
    return null;
  }

  return (
    <div className={cn("flex shrink-0 items-center justify-end gap-2 py-3", className)}>
      <span className="text-sm text-muted-foreground">
        {t("datatable.pagination.pageInfo", { page: page + 1, pageCount })}
      </span>
      <Button
        variant="outline"
        size="icon"
        disabled={page === 0}
        onClick={onPrevious}
        aria-label={t("datatable.pagination.previous")}
      >
        <ChevronLeft className="h-4 w-4" aria-hidden="true" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        disabled={page >= pageCount - 1}
        onClick={onNext}
        aria-label={t("datatable.pagination.next")}
      >
        <ChevronRight className="h-4 w-4" aria-hidden="true" />
      </Button>
    </div>
  );
}
